import Requests from "../../../../services/requests";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuLateral from "../../../../components/menu-lateral";
import MenuHeader from "../../../../components/menu-header";
import "./styles/birutasInfo.css";

export function BirutasInfo({ token }) {
    let config = { headers: { "x-access-token": token } };
    let { id } = useParams();

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllBirutasById(id, config).then((res) => {
                    setData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const formatDate = (date) => {
        const dataBanco = new Date(date);
        const dataFormatada = dataBanco.toLocaleDateString();
        return dataFormatada;
    };

    const convertBoll = (check) => {
        if (check === 0) return "Não";
        return "Sim";
    };

    console.log("data aqui:", data);

    return (
        <div>
            <div className="container-info-birutas">
                <header className="menu-header">
                    <MenuHeader />
                </header>
                <div className="menu-lateral-wrapper">
                    <MenuLateral />
                </div>
                <div className="title-container">
                    <h1 className="title">Birutas</h1>
                </div>
                {data.map((check, i) => {
                    return (
                        <div key={i}>
                            {check.birutasInspecionadas.map((biruta, i) => (
                                <main className="datagrid-container-birutas">
                                    <div className="table-content-birutas">
                                        <div key={i}>
                                            <thead>
                                                <h2 className="subtitle-birutas-page" key={i}>{biruta.local}</h2>
                                                <tr>
                                                    <th>Precisa de PTA</th>
                                                    <th>
                                                    Condição do tecido
                                                    </th>
                                                    <th>
                                                    Condição do estrutural
                                                    </th>
                                                    <th>
                                                    Data inspeção
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <td>
                                                    {biruta.pta ? convertBoll(biruta.pta) : "Não informado"}
                                                </td>
                                                <td>
                                                    {biruta.tecido ? biruta.tecido : "Não informado"}
                                                </td>
                                                <td>
                                                    {biruta.estrutural ? biruta.estrutural : "Não informado"}
                                                </td>
                                                <td>
                                                    {check.datahora_inspecao ? formatDate(check.datahora_inspecao) : "Não informado"}
                                                </td>
                                            </tbody>
                                        </div>
                                        <br></br>
                                        <br></br>
                                        <div key={i}>
                                            <thead>
                                                <tr>
                                                    <th>
                                                    Subistituida em
                                                    </th>
                                                    <th>
                                                    Ação
                                                    </th>
                                                    <th>
                                                        Responsável
                                                    </th>
                                                    <th>Prazo:</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <td>
                                                    {biruta.substituida ? formatDate(biruta.substituida) : "Não informado"}
                                                </td>
                                                <td>
                                                    {biruta.acao ? biruta.acao : "Não informado"}
                                                </td>
                                                <td>
                                                    {biruta.responsavel ? biruta.responsavel : "Não informado"}
                                                </td>
                                                <td>
                                                    {biruta.prazo ? formatDate(biruta.prazo) : "Não informado"}
                                                </td>
                                            </tbody>
                                        </div>
                                    </div>
                                </main>
                            ))}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
